import app from 'flarum/common/app';
import AbstractFileList from './AbstractFIleList';
export default class UserFileList extends AbstractFileList {
  loadFileList() {
    var _this$attrs$user;
    //app.fileListState.setUser(this.attrs.user || app.session.user);
    this.fileState.setUser((_this$attrs$user = this.attrs.user) != null ? _this$attrs$user : app.session.user);
    /**
     * The user who's media we are dealing with
     */
    this.user = this.fileState.user; //app.fileListState.user;
  }
  hasMoreResults() {
    return this.fileState.hasMoreResults();
  }
  loadMore() {
    this.fileState.loadMore();
  }
  isLoading() {
    return this.fileState.isLoading();
  }
  fileCollection() {
    return this.fileState.files;
  }
}
flarum.reg.add('fof-upload', 'common/components/UserFileList', UserFileList);